import React, { useState } from 'react';
import { ChevronRightIcon, ChevronLeftIcon, UsersIcon, UserIcon, PencilRulerIcon, BarChart3Icon, PieChartIcon, MapPinIcon, CalendarIcon, EyeIcon, EditIcon, DownloadIcon, ShareIcon, CopyIcon, TrashIcon, GlobeIcon, LayoutIcon, RulerIcon, DropletIcon, TagIcon, ListIcon, LayoutGridIcon, FoldersIcon } from 'lucide-react';
import { FolderView } from './FolderView';
// Mock data for dealer and customer designs
const dealerCustomerDesignsData = [{
  id: 'TZHE32',
  date: 'Jul 18, 2025',
  name: 'Western Irrigation Project',
  description: 'Large field pivot system with 4 pivots',
  dealerName: 'AiscoEurope SAU',
  dealerType: 'Direct Dealer',
  region: 'EUROPE',
  status: 'completed',
  model: 'Pivot CP600',
  pivotCount: 4,
  specs: {
    length: '298.81 m',
    angle: '360°',
    area: '33.27 ha',
    flow: '35.01 l/s',
    pressure: '2.00 bar'
  },
  createdBy: 'Daniel Fernández',
  lastModified: '2025-07-18',
  tags: ['Commercial', 'Multi-Pivot']
}, {
  id: 'T55NVQ',
  date: 'Jul 12, 2025',
  name: 'Нов оросен пункт',
  description: 'Irrigation system for eastern field',
  dealerName: 'HMB Irrigation',
  dealerType: 'Dealer',
  region: 'EUROPE',
  status: 'active',
  model: 'Pivot CP600',
  pivotCount: 1,
  specs: {
    length: '298.81 m',
    angle: '360°',
    area: '33.27 ha',
    flow: '35.01 l/s',
    pressure: '2.00 bar'
  },
  createdBy: 'Maria Petrova',
  lastModified: '2025-07-12',
  tags: ['Standard', 'Single-Pivot']
}, {
  id: 'HX6AA6',
  date: 'Jun 10, 2025',
  name: 'Valley Vineyard Project',
  description: 'Multi-pivot system for vineyard irrigation',
  dealerName: 'AiscoEurope SAU',
  dealerType: 'Direct Dealer',
  region: 'EUROPE',
  status: 'active',
  model: 'Pivot CP600',
  pivotCount: 3,
  specs: {
    length: '298.81 m',
    angle: '360°',
    area: '32.41 ha',
    flow: '40.63 l/s',
    pressure: '2.00 bar'
  },
  createdBy: 'Daniel Fernández',
  lastModified: '2025-06-10',
  tags: ['Vineyard', 'Multi-Pivot']
}, {
  id: '433F0L',
  date: 'Jun 10, 2025',
  name: 'New Pivot Design',
  description: 'Standard pivot for small field',
  dealerName: 'WEAKS MARTIN',
  dealerType: 'Dealer',
  region: 'EUROPE',
  status: 'active',
  model: 'Pivot CP600',
  pivotCount: 1,
  specs: {
    length: '298.81 m',
    angle: '360°',
    area: '32.41 ha',
    flow: '40.63 l/s',
    pressure: '2.00 bar'
  },
  createdBy: 'FERNANDO HERNANDEZ L',
  lastModified: '2025-06-10',
  tags: ['Standard', 'Single-Pivot']
}, {
  id: 'LM7KJ9',
  date: 'Jun 02, 2025',
  name: 'Linear System for Corn Field',
  description: 'Linear irrigation system for rectangular field',
  dealerName: 'VAN DIEMEN LAND IRRIGATION',
  dealerType: 'Dealer',
  region: 'AUSTRALIA',
  status: 'active',
  model: 'Linear',
  pivotCount: 1,
  specs: {
    length: '400.00 m',
    angle: 'N/A',
    area: '40.00 ha',
    flow: '45.00 l/s',
    pressure: '2.50 bar'
  },
  createdBy: 'John Quirk',
  lastModified: '2025-06-02',
  tags: ['Linear', 'Corn']
}, {
  id: 'P98RT2',
  date: 'May 25, 2025',
  name: 'Corner Arm Addition',
  description: 'Corner arm for existing pivot',
  dealerName: 'HMB Irrigation',
  dealerType: 'Dealer',
  region: 'AMERICA',
  status: 'pending',
  model: 'Corner Arm',
  pivotCount: 1,
  specs: {
    length: '65.00 m',
    angle: 'N/A',
    area: '+5.00 ha',
    flow: '+15.00 l/s',
    pressure: '2.20 bar'
  },
  createdBy: 'Benny Ginter',
  lastModified: '2025-05-25',
  tags: ['Corner', 'Upgrade']
}, {
  id: 'KL5MN7',
  date: 'May 15, 2025',
  name: 'High Profile CP600',
  description: 'High clearance pivot for tall crops',
  dealerName: 'Smith Family Farms',
  dealerType: 'Customer',
  region: 'AMERICA',
  status: 'completed',
  model: 'Pivot CP600',
  pivotCount: 1,
  specs: {
    length: '250.00 m',
    angle: '180°',
    area: '25.00 ha',
    flow: '30.00 l/s',
    pressure: '2.10 bar'
  },
  createdBy: 'Maria Rodriguez',
  lastModified: '2025-05-15',
  tags: ['High Profile', 'Half-Circle']
}, {
  id: 'WQ9JK2',
  date: 'May 10, 2025',
  name: 'Napa Valley Drip System',
  description: 'Precision drip system for vineyard',
  dealerName: 'Napa Valley Vineyards',
  dealerType: 'Customer',
  region: 'AMERICA',
  status: 'pending',
  model: 'Drip System',
  pivotCount: 0,
  specs: {
    length: 'N/A',
    angle: 'N/A',
    area: '15.00 ha',
    flow: '10.00 l/s',
    pressure: '1.50 bar'
  },
  createdBy: 'James Wilson',
  lastModified: '2025-05-10',
  tags: ['Drip', 'Vineyard']
}];
export function DealerCustomerDesigns({
  searchQuery,
  selectedDealer,
  selectedRegion,
  selectedModel
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [viewType, setViewType] = useState('grid'); // 'grid', 'list', or 'folders'
  const [dealerFilter, setDealerFilter] = useState('all'); // 'all', 'dealer', 'customer'
  const [statusFilter, setStatusFilter] = useState('all'); // 'all', 'active', 'completed', 'pending'
  const itemsPerPage = viewType === 'grid' ? 6 : 8;
  // Filter designs based on search query, filters, and dealer type
  const filteredDesigns = dealerCustomerDesignsData.filter(design => {
    const matchesSearch = searchQuery === '' || design.id.toLowerCase().includes(searchQuery.toLowerCase()) || design.name.toLowerCase().includes(searchQuery.toLowerCase()) || design.description.toLowerCase().includes(searchQuery.toLowerCase()) || design.createdBy.toLowerCase().includes(searchQuery.toLowerCase()) || design.dealerName.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesDealer = selectedDealer === 'all' || design.dealerName.toLowerCase().includes(selectedDealer.toLowerCase());
    const matchesRegion = selectedRegion === 'all' || design.region.toLowerCase() === selectedRegion.toLowerCase();
    const matchesModel = selectedModel === 'all' || design.model.toLowerCase().includes(selectedModel.toLowerCase());
    const matchesDealerType = dealerFilter === 'all' || dealerFilter === 'dealer' && design.dealerType.includes('Dealer') || dealerFilter === 'customer' && design.dealerType === 'Customer';
    const matchesStatus = statusFilter === 'all' || design.status === statusFilter;
    return matchesSearch && matchesDealer && matchesRegion && matchesModel && matchesDealerType && matchesStatus;
  });
  // Calculate pagination
  const totalPages = Math.ceil(filteredDesigns.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedDesigns = filteredDesigns.slice(startIndex, startIndex + itemsPerPage);
  // Calculate summary statistics
  const totalDesigns = filteredDesigns.length;
  const dealerCount = filteredDesigns.filter(d => d.dealerType.includes('Dealer')).length;
  const customerCount = filteredDesigns.filter(d => d.dealerType === 'Customer').length;
  const totalPivots = filteredDesigns.reduce((sum, design) => sum + design.pivotCount, 0);
  const handleViewDesign = design => {
    console.log('Viewing design:', design);
    // Aquí implementarías la lógica para ver un diseño
  };
  return <div data-id="element-2602" data-mp="2m7qe5cy3kjcp">
      {/* Dashboard summary */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 p-6 border-b border-gray-200 bg-gray-50" data-id="element-2603" data-mp="2m8s0weoh6ua9">
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2604" data-mp="2h9ymmk1d6z91">
          <div className="flex justify-between items-start" data-id="element-2605" data-mp="2vxs121eprvq1">
            <div data-id="element-2606" data-mp="2vzcu1mldr6ls">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2607" data-mp="2r738eirasspb">
                Total Designs
              </h3>
              <p className="text-4xl font-bold text-blue-600" data-id="element-2608" data-mp="34xf22m3j6zik">{totalDesigns}</p>
            </div>
            <div className="bg-blue-100 p-2 rounded-lg" data-id="element-2609" data-mp="2zzwsqullqia1">
              <PencilRulerIcon size={24} className="text-blue-600" data-id="element-2610" data-mp="301hmii03dx6u" />
            </div>
          </div>
          <div className="mt-4 flex gap-3" data-id="element-2611" data-mp="3eu1ohfbi9ymp">
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${dealerFilter === 'all' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setDealerFilter('all')} data-id="element-2612" data-mp="39yclf20a1zln">
              All ({totalDesigns})
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${dealerFilter === 'dealer' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setDealerFilter('dealer')} data-id="element-2613" data-mp="tqmesadre40p">
              <UserIcon size={12} className="mr-1" data-id="element-2614" data-mp="13gpk9a22hafx" />
              Dealers ({dealerCount})
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${dealerFilter === 'customer' ? 'bg-teal-100 text-teal-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setDealerFilter('customer')} data-id="element-2615" data-mp="18h3gzvy7wxyn">
              <UserIcon size={12} className="mr-1" data-id="element-2616" data-mp="kows1hutnt99" />
              Customers ({customerCount})
            </button>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2617" data-mp="osky1w3t2gse">
          <div className="flex justify-between items-start" data-id="element-2618" data-mp="1w3tgoqn3ggg3">
            <div data-id="element-2619" data-mp="205wwtskpk97p">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2620" data-mp="205f0yx1yjx0b">
                Total Pivots
              </h3>
              <p className="text-4xl font-bold text-indigo-600" data-id="element-2621" data-mp="3kmxpbh1ojtcs">
                {totalPivots}
              </p>
            </div>
            <div className="bg-indigo-100 p-2 rounded-lg" data-id="element-2622" data-mp="3goqhxct3w4e9">
              <LayoutIcon size={24} className="text-indigo-600" data-id="element-2623" data-mp="3buvsdsqtkv79" />
            </div>
          </div>
          <div className="mt-4 flex gap-3" data-id="element-2624" data-mp="36vrjz4bpz1hz">
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${selectedModel === 'all' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setSelectedModel('all')} data-id="element-2625" data-mp="36uzxcj03oe3u">
              All Models
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${selectedModel === 'cp600' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setSelectedModel('cp600')} data-id="element-2626" data-mp="2sxbdnehrrd0d">
              CP600
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${selectedModel === 'linear' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setSelectedModel('linear')} data-id="element-2627" data-mp="m7wpa3egr3sb">
              Linear
            </button>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2628" data-mp="3br4w2y7ohbdh">
          <div className="flex justify-between items-start" data-id="element-2629" data-mp="36tv7tlw0z5r8">
            <div data-id="element-2630" data-mp="2j2prl5m6abge">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2631" data-mp="2j27phsctx30k">Status</h3>
              <div className="flex items-center mt-2 gap-2" data-id="element-2632" data-mp="2f1nsqpw641ey">
                <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-2633" data-mp="2f38je4fd307j">
                  <div className="bg-green-500 h-2.5 rounded-full" style={{
                  width: `${filteredDesigns.filter(d => d.status === 'completed').length / totalDesigns * 100}%`
                }} data-id="element-2634" data-mp="2stkgyiuptr62"></div>
                </div>
              </div>
            </div>
            <div className="bg-green-100 p-2 rounded-lg" data-id="element-2635" data-mp="1vdy8r4uh35ga">
              <PieChartIcon size={24} className="text-green-600" data-id="element-2636" data-mp="1vbbyuyk40duw" />
            </div>
          </div>
          <div className="mt-4 flex gap-3" data-id="element-2637" data-mp="at9ksbohwotu">
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${statusFilter === 'all' ? 'bg-gray-100 text-gray-700 font-medium' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setStatusFilter('all')} data-id="element-2638" data-mp="fmcfin50e4bm">
              All
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${statusFilter === 'active' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setStatusFilter('active')} data-id="element-2639" data-mp="ujmnvnmcuu34">
              Active
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${statusFilter === 'completed' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setStatusFilter('completed')} data-id="element-2640" data-mp="kn9zn59kx8fr">
              Completed
            </button>
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${statusFilter === 'pending' ? 'bg-amber-100 text-amber-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setStatusFilter('pending')} data-id="element-2641" data-mp="3abslqsyz7p06">
              Pending
            </button>
          </div>
        </div>
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm" data-id="element-2642" data-mp="2hdyokxaphzz8">
          <div className="flex justify-between items-start" data-id="element-2643" data-mp="2cgq3anu9hftr">
            <div data-id="element-2644" data-mp="27i5aval940fv">
              <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-2645" data-mp="27ioj1zl3nagp">
                Regions
              </h3>
              <div className="mt-2" data-id="element-2646" data-mp="22hhavzf1o99i">
                <div className="flex justify-between text-sm mb-1" data-id="element-2647" data-mp="1ygxewz67jboy">
                  <span data-id="element-2648" data-mp="1yjb812hbudtv">Europe</span>
                  <span className="font-medium" data-id="element-2649" data-mp="1tiduj379i7yp">
                    {filteredDesigns.filter(d => d.region === 'EUROPE').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm mb-1" data-id="element-2650" data-mp="3ssvncywp03js">
                  <span data-id="element-2651" data-mp="3nwof2zgtqfyo">America</span>
                  <span className="font-medium" data-id="element-2652" data-mp="3vfo019jxofk5">
                    {filteredDesigns.filter(d => d.region === 'AMERICA').length}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-2653" data-mp="47a4ag2tsxhr">
                  <span data-id="element-2654" data-mp="914mtg6p36f9">Australia</span>
                  <span className="font-medium" data-id="element-2655" data-mp="9266ua5ov394">
                    {filteredDesigns.filter(d => d.region === 'AUSTRALIA').length}
                  </span>
                </div>
              </div>
            </div>
            <div className="bg-teal-100 p-2 rounded-lg" data-id="element-2656" data-mp="3hfvbnkvvqbfc">
              <GlobeIcon size={24} className="text-teal-600" data-id="element-2657" data-mp="3hgev5616h7vh" />
            </div>
          </div>
          <div className="mt-4 flex gap-3" data-id="element-2658" data-mp="3me6o83dk7019">
            <button className={`text-xs px-3 py-1.5 rounded-full flex items-center ${selectedRegion === 'all' ? 'bg-teal-100 text-teal-700' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} onClick={() => setSelectedRegion('all')} data-id="element-2659" data-mp="3qgl3yelxljob">
              All Regions
            </button>
          </div>
        </div>
      </div>

      {/* View type toggle */}
      <div className="flex justify-between items-center px-6 py-3 bg-white border-b border-gray-200" data-id="element-2660" data-mp="149ygbvn3c8f6">
        <div className="text-gray-700 font-medium" data-id="element-2661" data-mp="zbdmqf2cgmzp">
          {viewType !== 'folders' ? `${startIndex + 1}-${Math.min(startIndex + itemsPerPage, filteredDesigns.length)} of ${filteredDesigns.length} designs` : `${filteredDesigns.length} designs`}
        </div>
        <div className="flex border border-gray-200 rounded-lg overflow-hidden" data-id="element-2662" data-mp="1n7j4t1ly14z9">
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'list' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('list')} data-id="element-2663" data-mp="1i8y4l26oylat">
            <ListIcon size={16} className="mr-1" data-id="element-2664" data-mp="1wzx7pxorchn0" />
            List
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'grid' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('grid')} data-id="element-2665" data-mp="1rzjbdcwiqw4t">
            <LayoutGridIcon size={16} className="mr-1" data-id="element-2666" data-mp="21y8iqbqsgy6t" />
            Grid
          </button>
          <button className={`px-3 py-1.5 flex items-center ${viewType === 'folders' ? 'bg-blue-50 text-blue-600' : 'bg-white text-gray-600'}`} onClick={() => setViewType('folders')} data-id="element-2667" data-mp="2kmamwkced8ij">
            <FoldersIcon size={16} className="mr-1" data-id="element-2668" data-mp="2bl2swegwytu9" />
            Folders
          </button>
        </div>
      </div>

      {/* Designs list, grid or folders */}
      {viewType === 'folders' ? <div className="h-[calc(100vh-400px)] min-h-[400px]" data-id="element-2669" data-mp="21uzxy8q8f5ta">
          <FolderView designs={filteredDesigns} onViewDesign={handleViewDesign} data-id="element-2670" data-mp="21sn7t8ablp55" />
        </div> : viewType === 'grid' ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6" data-id="element-2671" data-mp="26nazth4j91oh">
          {paginatedDesigns.map(design => <DesignCard key={design.id} design={design} data-id="element-2672" data-mp="1wvdlw2m53vm2" />)}
          {paginatedDesigns.length === 0 && <div className="col-span-3 text-center py-12 text-gray-500" data-id="element-2673" data-mp="1ivvrn7q2rq5b">
              No designs found matching your search criteria
            </div>}
        </div> : <div className="overflow-x-auto" data-id="element-2674" data-mp="1nufgbfw1zg1d">
          <table className="w-full" data-id="element-2675" data-mp="3pk4iis2ldm0v">
            <thead className="bg-gray-50" data-id="element-2676" data-mp="3pl643qh8hqwu">
              <tr data-id="element-2677" data-mp="3plz488loti60">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2678" data-mp="3kto4b5qy5wdg">
                  ID
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2679" data-mp="3gsc98kpb0ixv">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2680" data-mp="ce4fqk18124q">
                  Dealer/Customer
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2681" data-mp="8a6f24w8zj9k">
                  Model
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2682" data-mp="3ui63jijkvvez">
                  Specs
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2683" data-mp="2j428sa56238v">
                  Region
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2684" data-mp="291otuvudnzok">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-2685" data-mp="2ixrshrq0tg6r">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-2686" data-mp="2rr4tzi25hq4g">
              {paginatedDesigns.map(design => <tr key={design.id} className="hover:bg-gray-50" data-id="element-2687" data-mp="2wp6or08xvdvr">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-2688" data-mp="2wrj4r7v4ze66">
                    {design.id}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2689" data-mp="36mujvragineg">
                    <div className="font-medium" data-id="element-2690" data-mp="17bjpd90xcsi3">{design.name}</div>
                    <div className="text-gray-500 text-xs" data-id="element-2691" data-mp="17d4gsprxzvbq">
                      {design.description}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2692" data-mp="3e63v7q2iww65">
                    <div data-id="element-2693" data-mp="3993l942jz99r">{design.dealerName}</div>
                    <div className="text-xs text-gray-500" data-id="element-2694" data-mp="3967nbfqpgklb">
                      {design.dealerType}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2695" data-mp="3iz6en5dl6p8m">
                    {design.model}
                    <div className="text-xs text-gray-500" data-id="element-2696" data-mp="2v92n3wdoafxz">
                      {design.pivotCount}{' '}
                      {design.pivotCount === 1 ? 'unit' : 'units'}
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2697" data-mp="3474km1y76qgi">
                    <div className="flex gap-2 text-xs" data-id="element-2698" data-mp="306c8n0xxy7gj">
                      <span className="bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full" data-id="element-2699" data-mp="ji8gt23hkgbr">
                        {design.specs.length}
                      </span>
                      <span className="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded-full" data-id="element-2700" data-mp="fjraulvsxbvx">
                        {design.specs.angle}
                      </span>
                      <span className="bg-green-50 text-green-700 px-2 py-0.5 rounded-full" data-id="element-2701" data-mp="s1lfs18m7633">
                        {design.specs.area}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-2702" data-mp="i3xbokp4cm89">
                    {design.region}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-2703" data-mp="1ar1jexfljenq">
                    <StatusBadge status={design.status} data-id="element-2704" data-mp="1ascor1oowugy" />
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-2705" data-mp="w1c500ihte5i">
                    <div className="flex space-x-2" data-id="element-2706" data-mp="10z47tpkoekoh">
                      <button className="text-blue-600 hover:text-blue-800" data-id="element-2707" data-mp="1oqjchozxde2w">
                        <EyeIcon size={16} data-id="element-2708" data-mp="1oogcqd8z06kz" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-2709" data-mp="1tiauvc8xgdhy">
                        <EditIcon size={16} data-id="element-2710" data-mp="3l35dz272xvwx" />
                      </button>
                      <button className="text-gray-600 hover:text-gray-800" data-id="element-2711" data-mp="3q1ox6uuagtll">
                        <ShareIcon size={16} data-id="element-2712" data-mp="3bcam9ib2e443" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
          {paginatedDesigns.length === 0 && <div className="text-center py-12 text-gray-500" data-id="element-2713" data-mp="32b32045dv3t0">
              No designs found matching your search criteria
            </div>}
        </div>}

      {/* Pagination - Only show if not in folder view */}
      {totalPages > 1 && viewType !== 'folders' && <div className="flex justify-between items-center px-6 py-4 border-t border-gray-200 bg-gray-50" data-id="element-2714" data-mp="2sf9jm44zgg3b">
          <button className="flex items-center text-gray-700 hover:text-blue-600 disabled:text-gray-400" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} data-id="element-2715" data-mp="2xem4ijcand39">
            <ChevronLeftIcon size={16} className="mr-1" data-id="element-2716" data-mp="vj27mxuu4n4u" />
            Previous
          </button>
          <div className="flex items-center gap-1" data-id="element-2717" data-mp="2g130t2vac60u">
            {Array.from({
          length: totalPages
        }, (_, i) => i + 1).map(page => <button key={page} className={`w-8 h-8 rounded-full flex items-center justify-center ${currentPage === page ? 'bg-blue-600 text-white' : 'text-gray-700 hover:bg-gray-100'}`} onClick={() => setCurrentPage(page)} data-id="element-2718" data-mp="2ptiidz2o6sl7">
                {page}
              </button>)}
          </div>
          <button className="flex items-center text-gray-700 hover:text-blue-600 disabled:text-gray-400" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} data-id="element-2719" data-mp="2tuluqblie6ho">
            Next
            <ChevronRightIcon size={16} className="ml-1" data-id="element-2720" data-mp="33tt9n37w696w" />
          </button>
        </div>}
    </div>;
}
// Helper component for design cards
function DesignCard({
  design
}) {
  const getStatusColor = status => {
    switch (status) {
      case 'active':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      case 'completed':
        return 'bg-green-100 text-green-700 border-green-200';
      case 'pending':
        return 'bg-amber-100 text-amber-700 border-amber-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };
  return <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-2721" data-mp="2d36vzll28eab">
      <div className="p-5 border-b border-gray-100" data-id="element-2722" data-mp="2i18qr3rum21m">
        <div className="flex justify-between items-start" data-id="element-2723" data-mp="2m33sg9doyhfx">
          <div data-id="element-2724" data-mp="2m1ixwjrdmyi2">
            <div className="flex items-center" data-id="element-2725" data-mp="2m0ze0xi6201e">
              <h3 className="font-bold text-gray-900 truncate max-w-[200px]" data-id="element-2726" data-mp="2qv3m5k364e42">
                {design.name}
              </h3>
              <span className="ml-2 bg-gray-100 text-gray-600 text-xs px-2 py-0.5 rounded-full" data-id="element-2727" data-mp="2vsdhthh5hm0c">
                {design.id}
              </span>
            </div>
            <p className="text-gray-600 text-sm mt-1" data-id="element-2728" data-mp="35qjlo4mip27u">{design.description}</p>
          </div>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(design.status)}`} data-id="element-2729" data-mp="u49bby8nx50a">
            {design.status.charAt(0).toUpperCase() + design.status.slice(1)}
          </span>
        </div>
        <div className="mt-4 flex items-center" data-id="element-2730" data-mp="k6usxt36i65c">
          <div className="h-10 w-10 rounded-full bg-indigo-100 flex items-center justify-center mr-3" data-id="element-2731" data-mp="k7mpb64lo7wo">
            <UserIcon size={18} className="text-indigo-600" data-id="element-2732" data-mp="1cuh9e1xi959m" />
          </div>
          <div data-id="element-2733" data-mp="1ctpgiyvalln1">
            <div className="text-sm font-medium text-gray-900" data-id="element-2734" data-mp="1cwbjel78ncyx">
              {design.dealerName}
            </div>
            <div className="text-xs text-gray-500" data-id="element-2735" data-mp="134e8lfk56n0q">{design.dealerType}</div>
          </div>
        </div>
      </div>
      <div className="px-5 py-4 flex justify-between items-center bg-gray-50 border-b border-gray-100" data-id="element-2736" data-mp="y6coqsew6jo7">
        <div className="flex items-center" data-id="element-2737" data-mp="1vl8cilqwfzfk">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ddVxmMM9BG37mQQDtAXhse/8120_pierce.svg" alt="Pivot Machine" className="h-12 mr-3" data-id="element-2738" data-mp="1vn1mob0q11sb" />
          <div data-id="element-2739" data-mp="1bbz3eqoyg2la">
            <div className="text-sm font-medium text-gray-900" data-id="element-2740" data-mp="1bbfmndb1jk8u">
              {design.model}
            </div>
            <div className="text-xs text-gray-500" data-id="element-2741" data-mp="1gcwk0yubgoko">
              {design.pivotCount} {design.pivotCount === 1 ? 'unit' : 'units'}
            </div>
          </div>
        </div>
        <div className="text-right" data-id="element-2742" data-mp="16e72j76c164y">
          <div className="text-sm font-medium text-gray-900" data-id="element-2743" data-mp="16f8erez33yo9">
            {design.region}
          </div>
          <div className="text-xs text-gray-500 flex items-center justify-end" data-id="element-2744" data-mp="1u4t7uqoyccb9">
            <CalendarIcon size={12} className="mr-1" data-id="element-2745" data-mp="1z11knxfoftf9" />
            {design.date}
          </div>
        </div>
      </div>
      <div className="px-5 py-4" data-id="element-2746" data-mp="1kb2og07oms2f">
        <h4 className="text-xs font-medium text-gray-500 mb-2" data-id="element-2747" data-mp="1pbi3qxbiy9n1">
          SPECIFICATIONS
        </h4>
        <div className="grid grid-cols-3 gap-2" data-id="element-2748" data-mp="2d1cbx1kwfa0y">
          <div className="bg-blue-50 rounded-lg p-2 text-center" data-id="element-2749" data-mp="2czhp1hq2h7u8">
            <div className="text-xs text-blue-600 mb-1 flex items-center justify-center" data-id="element-2750" data-mp="2ht2rblyp0nz8">
              <RulerIcon size={12} className="mr-1" data-id="element-2751" data-mp="6cacqbtrygl5" />
              Length
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-2752" data-mp="1f0ogzi4gayw">
              {design.specs.length}
            </div>
          </div>
          <div className="bg-indigo-50 rounded-lg p-2 text-center" data-id="element-2753" data-mp="g2loulnm3w34">
            <div className="text-xs text-indigo-600 mb-1 flex items-center justify-center" data-id="element-2754" data-mp="b3sg16j9st9a">
              <PieChartIcon size={12} className="mr-1" data-id="element-2755" data-mp="3jj2c9y0hb495" />
              Area
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-2756" data-mp="3elaieyg9x82b">
              {design.specs.area}
            </div>
          </div>
          <div className="bg-teal-50 rounded-lg p-2 text-center" data-id="element-2757" data-mp="3slbocsbeb5on">
            <div className="text-xs text-teal-600 mb-1 flex items-center justify-center" data-id="element-2758" data-mp="3oif8vah5jpox">
              <DropletIcon size={12} className="mr-1" data-id="element-2759" data-mp="17u1fqrw7c4z5" />
              Flow
            </div>
            <div className="text-sm font-medium text-gray-900" data-id="element-2760" data-mp="13szmcroyun53">
              {design.specs.flow}
            </div>
          </div>
        </div>
        <div className="mt-3 flex flex-wrap gap-1" data-id="element-2761" data-mp="h0mrmd4m29o">
          {design.tags.map((tag, index) => <span key={index} className="bg-gray-100 text-gray-700 text-xs px-2 py-0.5 rounded-full flex items-center" data-id="element-2762" data-mp="5fu2zmjss7dj" data-mpi={index}>
              <TagIcon size={10} className="mr-1" data-id="element-2763" data-mp="aghppw0zu21y" />
              {tag}
            </span>)}
        </div>
      </div>
      <div className="px-5 py-3 border-t border-gray-100 flex justify-between" data-id="element-2764" data-mp="efh4078m7b62">
        <div className="flex space-x-2" data-id="element-2765" data-mp="3dy9opudjrm9n">
          <button className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center" data-id="element-2766" data-mp="3ivt4iypw873p">
            <EyeIcon size={14} className="mr-1" data-id="element-2767" data-mp="3mxn04sl8ekx0" />
            View
          </button>
          <button className="text-gray-600 hover:text-gray-800 text-sm font-medium flex items-center" data-id="element-2768" data-mp="3mvjz7dijj7di">
            <EditIcon size={14} className="mr-1" data-id="element-2769" data-mp="2v674ya5lzpv6" />
            Edit
          </button>
        </div>
        <div className="flex space-x-2" data-id="element-2770" data-mp="2z7spmhodx8fx">
          <button className="text-gray-600 hover:text-gray-800" data-id="element-2771" data-mp="2z6r1pcm9srgs">
            <ShareIcon size={16} data-id="element-2772" data-mp="2ro1an17btj6a" />
          </button>
          <button className="text-gray-600 hover:text-gray-800" data-id="element-2773" data-mp="2rnrkndma7c0l">
            <DownloadIcon size={16} data-id="element-2774" data-mp="2moyek69bqnag" />
          </button>
        </div>
      </div>
    </div>;
}
// Helper component for status badges
function StatusBadge({
  status
}) {
  let config = {
    color: 'gray',
    text: 'Unknown'
  };
  switch (status) {
    case 'active':
      config = {
        color: 'blue',
        text: 'Active'
      };
      break;
    case 'completed':
      config = {
        color: 'green',
        text: 'Completed'
      };
      break;
    case 'pending':
      config = {
        color: 'amber',
        text: 'Pending'
      };
      break;
  }
  const colors = {
    blue: 'bg-blue-100 text-blue-800',
    green: 'bg-green-100 text-green-800',
    amber: 'bg-amber-100 text-amber-800',
    gray: 'bg-gray-100 text-gray-800'
  };
  return <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${colors[config.color]}`} data-id="element-2775" data-mp="1q0s7lcoxjit0">
      {config.text}
    </span>;
}